import React from 'react';
import PropTypes from 'prop-types';

const Button = ({ text, disabled }) => <button className={`btn btn-${disabled ? 'secondary' : 'submit'} form-button`} disabled={disabled} type="submit">{text}</button>;

Button.propTypes = { text: PropTypes.string.isRequired, disabled: PropTypes.bool.isRequired };

export default Button;
